import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import SessionHandler from './utils/sessionHandler';
import FormPage from './pages/FormsPage';

// Components
import LandingPage from './pages/LandingPage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/LoginPage';
import TopNavbar from './components/TopNavbar';
import Footer from './components/Footer';
import Dashboard from './components/Dashboard';
import TrainingForm from './components/TrainingForm';
import AppreciationWall from './components/BounceBot';
import ExcelDocuments from './pages/DocumentsPage';
import SchemesPage from './pages/SchemesPage';
import DocumentsPage from './pages/Documents';
import Ledger from './pages/Ledger';
import RIRDPage from './pages/RIRD';
import SIRDPage from './pages/SIRD';
import CareersPage from './pages/Careers';
import InfrastructureForm from './components/InfrastructureForm';
import Brcp from './components/BrcpEngagementForm';
import DrcpForm from './components/DrcpEngagementForm';
import Settings from './pages/Settings';
import MasterPage from './pages/Masters';
import SchemesForm from './pages/SchemesMaster';
import TitlesForm from './pages/TitleForm';
import ClienteleForm from './components/ClientilePage';
import TamilNaduDistrictMap from './components/TamilNaduDistrictMap';
import AdminForm from './components/AdminForm';
import ReportsPage from './pages/Reports';
import AttendancePage from './pages/AttendancePage';
import DocumentMaster from './pages/documents-master';
import DistrictWiseReports from './pages/DistrictWiseReports';
import RGSLedger from './pages/SourceOfFund';
import SFCLedger from './pages/SFC';
import IDFLedger from './pages/IDF';
import TCFLedger from './pages/TCF';
import OUTLedger from './pages/OUT';
import SFCReportPage from './pages/SFCReportPage';
import GoIReportPage from './pages/GoIReportPage';
import TCFIDFReportPage from './pages/TCFIDFReportPage';
import RGSReportPage from './pages/RGSReportPage';
import ReportFormatsPage from './pages/ReportsFormat';
import TrainingModulesPage from './pages/TrainingModules';
import CustomForms from './components/Forms';
import NatureClubDetail from './pages/NatureClubDetail'; // ADD THIS IMPORT

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem('isAuthenticated') === 'true');
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole') || '');

  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserRole('');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userRole');
    
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  };

  const AuthenticatedLayout = ({ children }) => (
    <div className="flex flex-col h-screen bg-gray-100">
      <TopNavbar userRole={userRole} onLogout={handleLogout} />
      <main className="flex-1 overflow-y-auto p-4 bg-gray-50">
        <div className="container mx-auto">
          {children}
        </div>
      </main>
    </div>
  );

  const PublicLayout = ({ children }) => (
    <>
      {children}
    </>
  );

  const RequireAuth = ({ children }) => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
  };

  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<PublicLayout><LandingPage /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><AboutPage /></PublicLayout>} />
        <Route path="/schemes" element={<PublicLayout><SchemesPage /></PublicLayout>} />
        <Route path="/documents" element={<PublicLayout><DocumentsPage /></PublicLayout>} />
        <Route path="/rird" element={<PublicLayout><RIRDPage/></PublicLayout>} />
        <Route path="/sird" element={<PublicLayout><SIRDPage/></PublicLayout>} />
        <Route path="/careers" element={<PublicLayout><CareersPage/></PublicLayout>} />
        <Route path="/map" element={<PublicLayout><TamilNaduDistrictMap/></PublicLayout>} />
        <Route path="/training-modules" element={<PublicLayout><TrainingModulesPage/></PublicLayout>} />
        
        {/* Nature Club Detail route - ADD THIS */}
        <Route path="/nature-club/:code" element={<PublicLayout><NatureClubDetail /></PublicLayout>} />
      
        {/* Login route */}
        <Route 
          path="/login" 
          element={
            isAuthenticated ? <Navigate to="/dashboard" /> : 
            <PublicLayout><LoginPage setIsAuthenticated={setIsAuthenticated} setUserRole={setUserRole} /></PublicLayout>
          } 
        />
        
        {/* Dashboard route */}
        <Route 
          path="/dashboard" 
          element={
            <RequireAuth>
              <Dashboard userRole={userRole} />
            </RequireAuth>
          } 
        />
        
        {/* Add Training route */}
        <Route 
          path="/add-training" 
          element={
            <RequireAuth>
              <TrainingForm />
            </RequireAuth>
          } 
        />

        {/* Report route */}
        <Route 
          path="/report" 
          element={
            <RequireAuth>
              <ReportsPage />
            </RequireAuth>
          } 
        />

        {/* RGS route */}
        <Route 
          path="/rgs" 
          element={
            <RequireAuth>
              <RGSLedger />
            </RequireAuth>
          } 
        />
        
        {/* District report route */}
        <Route 
          path="/district-report" 
          element={
            <RequireAuth>
              <DistrictWiseReports/>
            </RequireAuth>
          } 
        />
        
        {/* Attendance route */}
        <Route 
          path="/attendance" 
          element={
            <RequireAuth>
              <AttendancePage/>
            </RequireAuth>
          } 
        />

        {/* Ledger route */}
        <Route 
          path="/ledger" 
          element={
            <RequireAuth>
              <Ledger/>
            </RequireAuth>
          } 
        />

        {/* Add admin route */}
        <Route 
          path="/add-admin" 
          element={
            <RequireAuth>
              <AdminForm/>
            </RequireAuth>
          } 
        />

        {/* IDF route */}
        <Route 
          path="/idf" 
          element={
            <RequireAuth>
              <IDFLedger/>
            </RequireAuth>
          } 
        />

        {/* TCF route */}
        <Route 
          path="/tcf" 
          element={
            <RequireAuth>
              <TCFLedger/>
            </RequireAuth>
          } 
        />

        {/* OUT route */}
        <Route 
          path="/out" 
          element={
            <RequireAuth>
              <OUTLedger/>
            </RequireAuth>
          } 
        />

        {/* Add Clientele route */}
        <Route 
          path="/add-clientele" 
          element={
            <RequireAuth>
              <ClienteleForm />
            </RequireAuth>
          } 
        />
        
        {/* Add Clientele route */}
        <Route 
          path="/forms" 
          element={
            <RequireAuth>
              <CustomForms />
            </RequireAuth>
          } 
        />
        
        {/* Individual Form Page */}
        <Route 
          path="/form/:formId" 
          element={
            <RequireAuth>
              <FormPage />
            </RequireAuth>
          } 
        />
        
        {/* Add documents route */}
        <Route 
          path="/add-documents" 
          element={
            <RequireAuth>
              <DocumentMaster />
            </RequireAuth>
          } 
        />
        
        {/* Add Schemes route */}
        <Route 
          path="/add-schemes" 
          element={
            <RequireAuth>
              <SchemesForm />
            </RequireAuth>
          } 
        />
        
        {/* Add Schemes route */}
        <Route 
          path="/excel" 
          element={
            <RequireAuth>
              <ExcelDocuments />
            </RequireAuth>
          } 
        />

        {/* SFC route */}
        <Route 
          path="/sfc" 
          element={
            <RequireAuth>
              <SFCLedger />
            </RequireAuth>
          } 
        />

        {/* Add Titles route */}
        <Route 
          path="/add-titles" 
          element={
            <RequireAuth>
              <TitlesForm />
            </RequireAuth>
          } 
        />
        
        {/* Settings route */}
        <Route 
          path="/settings" 
          element={
            <RequireAuth>
              <Settings/>
            </RequireAuth>
          } 
        />
        
        {/* Add Infrastructure route */}
        <Route 
          path="/add-infra" 
          element={
            <RequireAuth>
              <InfrastructureForm />
            </RequireAuth>
          } 
        />
        
        {/* Report routes */}
        <Route 
          path="/report-sfc" 
          element={
            <RequireAuth>
              <SFCReportPage />
            </RequireAuth>
          } 
        />
        
        <Route 
          path="/report-tcf-idf" 
          element={
            <RequireAuth>
              <TCFIDFReportPage/>
            </RequireAuth>
          } 
        />
        
        <Route 
          path="/report-goi" 
          element={
            <RequireAuth>
              <GoIReportPage/>
            </RequireAuth>
          } 
        />
        
        <Route 
          path="/report-rgs" 
          element={
            <RequireAuth>
              <RGSReportPage/>
            </RequireAuth>
          } 
        />

        {/* BRCP route */}
        <Route 
          path="/brcp" 
          element={
            <RequireAuth>
              <Brcp />
            </RequireAuth>
          } 
        />

        {/* Masters route */}
        <Route 
          path="/masters" 
          element={
            <RequireAuth>
              <MasterPage />
            </RequireAuth>
          } 
        />
        
        {/* DRCP route */}
        <Route 
          path="/drcp" 
          element={
            <RequireAuth>
              <DrcpForm />
            </RequireAuth>
          } 
        />
        
        {/* Catch-all */}
        <Route 
          path="*" 
          element={isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/" />} 
        />
      </Routes>
    </Router>
  );
}

export default App;